import { ElementType } from '~/utils/constants/ui';
import type { ITokenModel } from '~/types/apiService';
import type { Bundle } from '~/types/bundles';
import type { IListItem } from '~/types/list';

export interface CustomButton {
  type: ElementType;
  key: MarketplaceSections;
  label: string;
  sectionLabel: string;
  src: string;
}

export enum MarketplaceSections {
  TokenSets = 'tokenSets'
}

export interface ITokenOptionItem extends ITokenModel {
  apr: number;
  label: string;
  src: string;
}

export interface MultiTokenPackItem extends Pick<Bundle, 'priceAmount' | 'originalPriceAmount' | 'bundleId'> {
  title: string;
  src: string;
  items: IListItem[];
  isAvailable: boolean;
  isOneTimeOffer: boolean;
  remainingCount: number;
  timeToReset: number;
}
